/* globals document */

export function disableTouchScroll(id) {
  const container = document.getElementById(id);
  document.body.addEventListener('touchmove', function (e) { // eslint-disable-line prefer-arrow-callback, max-len
    const touchEl = document.elementFromPoint(e.targetTouches[0].pageX, e.targetTouches[0].pageY);
    if (container.contains(touchEl)) {
      // e.preventDefault();
    }
  });
}

export function useImperialUnits(language) {
  const imperialCodes = ['en', 'en-US', 'en-GB', 'lir', 'my', 'bur', 'mya'].map(
    code => code.toLowerCase());
  return imperialCodes.indexOf(language.toLowerCase()) !== -1;
}

export function getEndpointFromUrl(url) {
  if (!url) return null;
  const re = /^(?:https?:\/\/.+?)?\/api\/v1\/(.+)$/;
  const match = url.match(re);
  if (match) return match[1];
  return url;
}



// WEBPACK FOOTER //
// ./app/scripts/utils/index.jsx